module.exports = __webpack_public_path__ + "static/media/g3.f50bdf04.jpg";